//============================================================================
// Name        : globalSettings.ts
// Purpose     : Settings and globals shared by many components
// Created     : 2019-07-04
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

declare module "redux" {
    export type GenericStoreEnhancer = any;
}

export const selectCustomStyle = {
    control: (base: any) => ({
        ...base,
        minHeight: 30
    }),
    dropdownIndicator: (base: any) => ({
        ...base,
        padding: 4
    }),
    clearIndicator: (base: any) => ({
        ...base,
        padding: 4
    }),
    multiValue: (base: any) => ({
        ...base
        // backgroundColor: variables.colorPrimaryLighter
    }),
    valueContainer: (base: any) => ({
        ...base,
        padding: "0px 6px"
    }),
    input: (base: any) => ({
        ...base,
        margin: 0,
        padding: 0
    })
};

export function getEndpoint() {
    const locParts = location.href.split("/").filter(x => x);
    return locParts[0] + "//" + locParts[1] + "/" + locParts[2] + "/" + locParts[3] + "/";
}

export function getApiEndpoint() {
    const locParts = location.href.split("/").filter(x => x);
    return locParts[0] + "//" + locParts[1] + "/" + locParts[2] + "/" + locParts[3] + "/api/v1/";
}
